import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { browserHistory } from 'react-router';
import CSSModules from 'react-css-modules';

import { PUBLIC_PROFILE } from '../../../../constants/routes';
import { ICON_BLOCK } from '../../../../constants/chat';
import { COLORS } from '../../../../constants/styles';
import { IDS } from '../../../../constants/ids';
import Avatar from '../../../Avatar';
import Card from '../../../Card';
import Icon from '../../../Icon';
import styles from '../index.styl';

function ListItem({ item, showMenu, loggedUserId, avatarSize, onClick, type }) {
  const { id, avatar, providerRole, aliasName, blocked } = item;
  const { url } = avatar || {};

  const redirectToProfile = () => {
    browserHistory.push(`${PUBLIC_PROFILE}/${id}`);
  };

  const memberAvatar = (
    <Avatar
      className={blocked ? 'o-50' : ''}
      children={aliasName}
      size={avatarSize}
      src={url}
    />
  );

  return (
    <div styleName="list-item">
      <Card
        userId={id}
        className="fw6 pointer"
        text={{
          primary: aliasName,
          complementary: providerRole,
        }}
        additionalContent={{
          left: memberAvatar,
        }}
        additionalIcons={blocked ? [ICON_BLOCK] : null}
        handleClick={redirectToProfile}
      />
      <If condition={item.id !== loggedUserId && showMenu}>
        <div
          styleName="list-item__icon"
          onClick={e => onClick(e, item, type)}
          id={IDS.COMMUNITY.MEMBER_MENU_TRIGGER}
        >
          <Icon name="more" size={12} style={{ fill: COLORS.cloudyBlue }} />
        </div>
      </If>
    </div>
  );
}

ListItem.propTypes = {
  showMenu: PropTypes.bool,
  item: PropTypes.object.isRequired,
  loggedUserId: PropTypes.number.isRequired,
  avatarSize: PropTypes.number,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
};

ListItem.defaultProps = {
  avatarSize: 24,
};

export default compose(
  injectIntl,
  CSSModules(styles, { allowMultiple: true }),
)(ListItem);



// WEBPACK FOOTER //
// ./src/components/Community/About/ListItem/index.jsx